import { reducer } from './newCollection';

export const TYPE = 'POSTING_RULES';

export const urls = {
    getRules: '/api/posting/rules',
    getSuggestedTitle: '/api/title/suggestions',
    getPostingConfig: '/api/rocket/configurations',
    getInspectionConsent: '/api/inspection/consent',
    postAdData: '/api/inspection/ad',
    getPredictionPrices: '/api/rocket/pricing/info',
    previewAd: '/api/inspection/ad/preview',
    getPopularBrandsImage: '/api/rocket/configuration'
};

const initialState = {
    titleKeySuggestion: 'manual',
    titleVariantSelected: '',
    isLoadingTitleSuggestion: false,
    shuffledTitleSuggestions: [],
    pricePredictionData: {},
    suggestedPrice: ''
};

const shuffleData = data => {
    if (data && data.suggestions) {
        return data.suggestions.sort(() => Math.random() - 0.5); // eslint-disable-line no-magic-numbers
    }
    return [];
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REQUEST_TITLE_SUGGESTIONS_DATA': {
            return {
                ...state,
                isLoadingTitleSuggestion: true,
                shuffledTitleSuggestions: action.data
            };
        }
        case 'RECEIVE_TITLE_SUGGESTIONS_DATA': {
            return {
                ...state,
                isLoadingTitleSuggestion: false,
                shuffledTitleSuggestions: shuffleData(action.data)
            };
        }
        case 'ERROR_TITLE_SUGGESTIONS_DATA': {
            return {
                ...state,
                isLoadingTitleSuggestion: false
            };
        }
        case 'REQUEST_TITLE_SUGGESTIONS_TYPE': {
            return {
                ...state,
                titleKeySuggestion: action.data
            };
        }
        case 'REQUEST_TITLE_SUGGESTIONS_VARIANT': {
            return {
                ...state,
                titleVariantSelected: action.data
            };
        }
        case `RECEIVE_${TYPE}`:
            return {
                ...state,
                rules: { ...action.data.data.rules }
            };
        case 'RECEIVE_POSTING_CONFIG':
            return {
                ...state,
                postingConfig: action.data
            };
        case 'REQUEST_PRICE_PREDICTION_DATA':
        case 'RESPONSE_POST_PRICE_PREDICTION_DATA': {
            return {
                ...state,
                pricePredictionData: action.data
            };
        }
        default:
            return reducer(state, action, TYPE);
    }
};
